<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="search()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/processWareHouse/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="search()">搜索</el-button>
				<el-button v-if="$checkBtnPermission('/processWareHouse/index', 'reset')" size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="商品信息：">
					<el-cascader
						v-model="goodsTypeValue"
						size="small"
						:options="goodsTypeList"
						:props="cascaderProps"
						placeholder="请选择商品信息"
						clearable
						filterable
						@change="handleTypeChange"
					></el-cascader>
				</el-form-item>
				<el-form-item label="球镜：">
					<el-select v-model="formInline.qiuJingKeyId" placeholder="请选择球镜" clearable filterable size="small" @change="search">
						<el-option v-for="item in qiuJingList" :key="item.keyId" :label="item.paramsValue" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="柱镜：">
					<el-select v-model="formInline.zhuJingKeyId" placeholder="请选择柱镜" clearable filterable size="small" @change="search">
						<el-option v-for="item in zhuJingList" :key="item.keyId" :label="item.paramsValue" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否预警：">
					<el-select v-model.number="formInline.isWarning" placeholder="请选择" size="small" @change="search">
						<el-option label="全部" :value="0"></el-option>
						<el-option label="仅预警" :value="1"></el-option>
					</el-select>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border height="520" @get-data="getListData">
				<template #quantity>
					<el-table-column align="center" label="库存数量" width="100">
						<template #default="scope">
							<span :class="scope.row.isWarning ? 'text-danger' : ''">{{ scope.row.quantity }}</span>
						</template>
					</el-table-column>
				</template>
				<template #operate>
					<el-table-column align="center" label="操作" width="200" fixed="right">
						<template #default="scope">
							<el-button v-if="$checkBtnPermission('/processWareHouse/index', 'updateQty')" type="text" size="small" @click="handleUpdateQty(scope.row)">调整库存</el-button>
							<el-button v-if="$checkBtnPermission('/processWareHouse/index', 'history')" type="text" size="small" @click="handleSeeHistory(scope.row)">库存流水</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>

		<lcsj-dialog v-model="updateVisible" title="调整库存" width="460px" cancel-text="取消" confirm-text="确定"
			 :confirm-loading="saveLoading"
			 :close-on-click-modal="false"
			 append-to-body
			 @confirm="submitUpdateQty">
			<el-form label-width="100px" size="small">
				<el-form-item label="商品：">
					<span>{{ updateRow.goodsTypeName }} {{ updateRow.goodsName }} {{ updateRow.qiuJing }} {{ updateRow.zhuJing }}</span>
				</el-form-item>
				<el-form-item label="当前库存：">
					<span>{{ updateRow.quantity }}</span>
				</el-form-item>
				<el-form-item label="调整后数量：" required>
					<el-input v-model.number="updateForm.quantity" type="number" placeholder="请输入调整后的库存数量"></el-input>
				</el-form-item>
				<el-form-item label="调整原因：">
					<el-input v-model="updateForm.remark" type="textarea" :rows="3" maxlength="50" show-word-limit placeholder="请输入调整原因"></el-input>
				</el-form-item>
			</el-form></lcsj-dialog>

		<processWareHouseHistory ref="processWareHouseHistory"></processWareHouseHistory>
	</div>
</template>

<script>
import { GetProcessWareHousePageList, UpdateProcessWareHouseQty } from "@/api/processApi.js";
import { GetAllGoodsTypeTreePageList, GetGoodsParamsList } from "@/api/baseDataApi.js";
import processWareHouseHistory from "./history.vue";
export default {
	components: {
		processWareHouseHistory
	},
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "库存列表"
				}
			],
			pageShow: true,
			loading: false,
			saveLoading: false,
			listData: [],
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			goodsTypeList: [],
			goodsTypeValue: [],
			qiuJingList: [],
			zhuJingList: [],
			cascaderProps: {
				value: "keyId",
				label: "name",
				children: "subList",
				checkStrictly: true,
				expandTrigger: "click"
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				goodsTypeKeyId: "",
				qiuJingKeyId: "",
				zhuJingKeyId: "",
				isWarning: 0
			},
			updateVisible: false,
			updateRow: {},
			updateForm: {
				goodsKeyId: "",
				quantity: 0,
				remark: ""
			},
			columnsData: [],
			listColumns: [
				{ prop: "rowNumber", label: "序号", align: "center", width: "70", isKeep: true },
				{ prop: "goodsTypeName", label: "商品品牌", align: "center", isKeep: true, width: "140" },
				{ prop: "goodsName", label: "商品名称", align: "center", isKeep: true, minWidth: "200" },
				{ prop: "qiuJing", label: "球镜", align: "center", isKeep: true, width: "90" },
				{ prop: "zhuJing", label: "柱镜", align: "center", isKeep: true, width: "90" },
				{ prop: "unit", label: "单位", align: "center", width: "80" },
				{ slot: "quantity", label: "库存数量", align: "center", isKeep: true, width: "100" },
				{ prop: "warningQuantity", label: "预警库存", align: "center", width: "100" },
				{ prop: "stockQuantity", label: "常备库存", align: "center", width: "100" },
				{ prop: "updateTime", label: "最后变更时间", align: "center", width: "170" },
				{ slot: "operate", label: "操作", align: "center", isKeep: true, width: "200" }
			]
		};
	},
	created() {
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetAllGoodsTypeTreePageList();
		this.GetGoodsParamsList();
		this.getListData();
	},
	methods: {
			changePages(tab) {
				this.activeTab = tab;
			},
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		GetAllGoodsTypeTreePageList() {
			GetAllGoodsTypeTreePageList({})
				.then((res) => {
					if (res.code == 1) {
						this.goodsTypeList = res.data || [];
					}
				})
				.catch(() => {});
		},
		GetGoodsParamsList() {
			GetGoodsParamsList({})
				.then((res) => {
					if (res.code == 1) {
						this.qiuJingList = (res.data || []).filter((item) => item.type == 1);
						this.zhuJingList = (res.data || []).filter((item) => item.type == 2);
					}
				})
				.catch(() => {});
		},
		handleTypeChange(value) {
			this.formInline.goodsTypeKeyId = value && value.length > 0 ? value[value.length - 1] : "";
			this.search();
		},
		getListData() {
			this.loading = true;
			GetProcessWareHousePageList(this.formInline)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.listData = res.data || [];
						this.pageparm.total = res.totalNumber;
					} else {
						this.listData = [];
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.goodsTypeValue = [];
			this.search();
		},
		callFather(parm) {
			this.formInline.pageIndex = parm.currentPage == undefined ? 1 : parm.currentPage;
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		handleUpdateQty(row) {
			this.updateRow = row;
			this.updateForm = {
				goodsKeyId: row.goodsKeyId,
				quantity: row.quantity,
				remark: ""
			};
			this.updateVisible = true;
		},
		submitUpdateQty() {
			if (this.updateForm.quantity === null || this.updateForm.quantity === "" || this.updateForm.quantity < 0) {
				this.$message({ type: "warning", message: "请输入正确的调整后数量！" });
				return;
			}
			this.saveLoading = true;
			UpdateProcessWareHouseQty(this.updateForm)
				.then((res) => {
					if (res.code == 1) {
						this.$message({ type: "success", message: "调整成功！" });
						this.updateVisible = false;
						this.search();
					} else {
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.$message.error("调整失败，请稍后再试！");
				})
				.finally(() => {
					this.saveLoading = false;
				});
		},
		handleSeeHistory(row) {
			this.$refs.processWareHouseHistory.showHistoryDialog(row);
		}
	}
};
</script>

<style scoped>
.text-danger {
	color: var(--app-danger);
}
</style>
